import s from '../s';

/**
 * A Fast Ship product (the control's icon rule): the product's own setup of an in-stock (AisleA) item, on a retail page. The tags go
 * on the product's own moulding and mat and on standard glass; s.ui.fast_ship_now says whether the current picks still qualify.
 */
export const fastShipItem = (): boolean => s.__fast_ship_orig && s.isRetail && !s.prod.IsCAF;

/**
 * Whether the tagged picks decide Fast Ship: the school, the seal and the document size are still the product's own (the other
 * parts pulse_fast_ship compares), so going back to the options marked Fast Ship brings it back.
 */
export const fastShipTagsDecide = (): boolean => !s.prod.IsFrame || (s.ps.lino_id === s.prod.LinoID && s.ps.insignia_id === s.prod.InsigniaID && !(s.si.AutomatedDocSizes && s.docsizes_enabled && s.docsizes_available && s.docsizes_selected_id !== s.docsizes_orig_id));
